
const initialState = ()=>({
    leadDraft:null,
});
const state = initialState();

const mutations = {
    SET_LEAD_DRAFT(state, draft) {
      state.leadDraft = draft;
    },
    RESET_STATE(state) {
        const newState = initialState();
        Object.keys(newState).forEach(key => {
          state[key] = newState[key];
        });
      },
  };
const actions = {
    saveLeadDraft({ commit }, draft) {
      commit('SET_LEAD_DRAFT', draft);
    },
    clearLeadDraft({ commit }) {
      commit('SET_LEAD_DRAFT', null);
    }
  };
  
export default {
    namespace: true,
    state,
    actions,
    mutations,
};
  